import React, {useState} from 'react';
import {Form, Input, Button, Card, message, Select} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import axios from 'axios';
import MathText from "../../components/MathText";
import {API_BASE_URL} from "../../config";
import FileUploader from "../../components/FileUploader";

const AddQuestion = () => {
    const [form] = Form.useForm();
    const [qContent, setQContent] = useState('');
    const [qVariant1, setQVariant1] = useState('');
    const [qVariant2, setQVariant2] = useState('');
    const [qVariant3, setQVariant3] = useState('');
    const [qVariant4, setQVariant4] = useState('');
    const navigate = useNavigate();
    const {collection_id} = useParams();

    const refactorContent = (content) => {
        if (content.includes("\n\n")) {
            const parts = content
                .split(/\n{2,}/)
                .map(part => part.trim())
                .filter(Boolean);

            const fieldsToUpdate = {};

            if (parts.length > 0) {
                setQContent(parts[0]);
            }
            if (parts.length > 1) {
                setQVariant1(parts[1].startsWith('A)')?parts[1].slice(2):parts[1]);
            }
            if (parts.length > 2) {
                setQVariant2(parts[2].startsWith('B)')?parts[2].slice(2):parts[2]);
            }
            if (parts.length > 3) {
                setQVariant3(parts[3].startsWith('C)')?parts[3].slice(2):parts[3]);
            }
            if (parts.length > 4) {
                setQVariant4(parts[4].startsWith('D)')?parts[4].slice(2):parts[4]);
            }
            form.setFieldsValue(fieldsToUpdate);
        }
    };


    const onValuesChange = (changedValues) => {
        if ('content' in changedValues) {
            refactorContent(changedValues.content)
            // setQContent(changedValues.content);
        }
    };


    const handleImageInsert = (file_name) => {
        const currentContent = form.getFieldValue('content') || '';
        const updatedContent = currentContent + `$\\includegraphics[width=0.4\\textwidth]{${file_name}}$`;
        form.setFieldsValue({content: updatedContent});
        setQContent(updatedContent);
    };

    const onFinish = async (values) => {
        try {
            values['content'] = qContent
            values['variant1'] = qVariant1
            values['variant2'] = qVariant2
            values['variant3'] = qVariant3
            values['variant4'] = qVariant4
            await axios.post(`${API_BASE_URL}/api/Question`, {
                ...values,
                collectionId: parseInt(collection_id, 10),
            });
            message.success('Question added');
            navigate(`/collection/${collection_id}/questions`);
        } catch (error) {
            message.error('Failed to add question');
        }
    };

    return (
        <Card title="Add Question" style={{maxWidth: 600, margin: 'auto'}}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                onValuesChange={onValuesChange}
            >
                <Form.Item
                    name="content"
                    label={
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 10
                        }}>
                            <label style={{fontWeight: 500, paddingRight: 20}}>
                                Content
                            </label>
                            <FileUploader setImage={handleImageInsert}/>
                        </div>
                    }
                    rules={[{required: true}]}
                >
                    <Input.TextArea rows={12} placeholder="Enter question content"/>
                </Form.Item>
                <MathText text={qContent}/><br/>
                <MathText text={`A) ${qVariant1}`}/><br/>
                <MathText text={`B) ${qVariant2}`}/><br/>
                <MathText text={`C) ${qVariant3}`}/><br/>
                <MathText text={`D) ${qVariant4}`}/><br/>
                <Form.Item
                    name="answer"
                    label="Answer"
                    rules={[{required: true}]}
                >
                    <Select placeholder="Select correct answer">
                        <Select.Option value="A">A</Select.Option>
                        <Select.Option value="B">B</Select.Option>
                        <Select.Option value="C">C</Select.Option>
                        <Select.Option value="D">D</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    key='link'
                    name='link'
                    label='Video link'
                    rules={[{required: false}]}
                >
                    <Input placeholder={`Paste here video url from telegram`}/>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Add Question</Button>
                </Form.Item>
                <Form.Item>
                    <Button onClick={() => navigate(`/collection/${collection_id}/questions`)}>
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default AddQuestion;
